import { useState, useEffect } from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import logger from '../../services/LocalServer/logger';
import ClickOutSideDiv from '../ShoppingCart/ClickOutSideDiv';

function KeyBoard(props) {
  const [layout, setLayout] = useState('default');
  const { input, setInput, keyboard, show, setShow, send, setReceiptSend, error, setError } = props;

  const onChange = (input) => {
    setInput(input);
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
  };

  const onKeyPress = (button) => {
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{.?123}') handle123();
    if (send) {
      if (button === '{enter}') {
        if (error === '' && input !== '') {
          console.log(error);
          setShow(false);
          setReceiptSend(true);
          keyboard.current.blur();
        }
        if (input === '') {
          setError('Email address can not be empty');
        }
      }
    }
  };

  const handle123 = () => {
    const newLayoutName = layout === 'onetwo' ? 'default' : 'onetwo';
    setLayout(newLayoutName);
  };

  const mylayout = {
    default: [
      'Q W E R T Y U I O P {bksp}',
      'A S D F G H J K L {enter}',
      '{shift} Z X C V B N M @ . {shift}',
      '{.?123} .com = {space} _ - +',
    ],
    shift: [
      'q w e r t y u i o p {bksp}',
      'a s d f g h j k l {enter}',
      '{shift} z x c v b n m @ . {shift}',
      '{.?123} .com = {space} _ - +',
    ],
    onetwo: [
      '1 2 3 4 5 6 7 8 9 0 {bksp}',
      '! # $ % ^ & * ( ) {enter}',
      '{shift} ; : \' " < > / ? . {shift}',
      '{.?123} .com = {space} _ - +',
    ],
  };

  const display = {
    '{enter}': 'return',
    '{tab}': 'tab',
    '{bksp}': 'back',
    '{shift}': 'shift',
    '{space}': ' ',
    '{lock}': 'caps',
    '{.?123}': '.?123',
  };

  const buttonTheme = [
    {
      class: 'button-left-margin',
      buttons: 'A a !',
    },
    {
      class: 'button-length1',
      buttons: '{enter}',
    },
    {
      class: 'button-length2',
      buttons: '{space}',
    },
    {
      class: 'button-color1',
      buttons: '{shift} .?123 .com =',
    },
  ];

  return (
    // <ClickOutSideDiv setShowCart={props.setShow}>
    <div>
      {show && (
        <div className="email-keyboard-container">
          <Keyboard
            id="my-keyboard"
            // keyboardRef={(r) => (keyboard.current = r)}
            layoutName={layout}
            layout={mylayout}
            onChange={onChange}
            onKeyPress={onKeyPress}
            preventMouseDownDefault={true}
            buttonTheme={buttonTheme}
            display={display}
          />
        </div>
      )}
    </div>
    /* </ClickOutSideDiv> */
  );
}
export default KeyBoard;
